/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorInquiryDto } from '../../models/create-vendor-inquiry-dto';
import { VendorInquiryDto } from '../../models/vendor-inquiry-dto';

export interface VendorInquiryControllerCreate$Params {
  clientWorkspaceId: string;
      body: CreateVendorInquiryDto
}

export function vendorInquiryControllerCreate(http: HttpClient, rootUrl: string, params: VendorInquiryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorInquiryDto>> {
  const rb = new RequestBuilder(rootUrl, vendorInquiryControllerCreate.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorInquiryDto>;
    })
  );
}

vendorInquiryControllerCreate.PATH = '/api/v1/vendorInquiry/{clientWorkspaceId}';
